import { Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { GetProductByPathApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import {
    chain,
    DispatchCompleteLoadProduct,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Data/Products/Handlers/LoadProductByPath";
import { ImageModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
type Parameter = {
    path: string;
    addToRecentlyViewed?: boolean;
} & HasOnSuccess<ProductModel>;
type Props = {
    apiParameter: GetProductByPathApiV2Parameter;
    apiResult: ProductModel;
};

type HandlerType = Handler<Parameter, Props>;

export const PopulateApiParameterCustom: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
        expand: [
            "detail",
            "specifications",
            "content",
            "images",
            "documents",
            "attributes",
            "variantTraits",
            "properties",
        ],
        includeAttributes: ["includeOnProduct"],
    };
};

export const DispatchCompleteLoadProductCustom: HandlerType = props => {
    if (props.apiResult.properties.video1Url || props.apiResult.properties.video2Url) {
        const videoObj1: ImageModel = {
            id: props.apiResult.properties.video1Url,
            imageAltText: props.apiResult.properties.video1Title,
            imageType: "video",
            largeImagePath: props.apiResult.properties.video1Url,
            mediumImagePath: props.apiResult.properties.video1Url,
            smallImagePath: props.apiResult.properties.thumbnail1Url,
            name: props.apiResult.properties.video1Title,
            sortOrder: 40,
        };

        const videoObj2: ImageModel = {
            id: props.apiResult.properties.video2Url,
            imageAltText: props.apiResult.properties.video2Title,
            imageType: "video",
            largeImagePath: props.apiResult.properties.video2Url,
            mediumImagePath: props.apiResult.properties.video2Url,
            smallImagePath: props.apiResult.properties.thumbnail2Url,
            name: props.apiResult.properties.video2Title,
            sortOrder: 41,
        };

        props.dispatch({
            type: "Data/Products/CompleteLoadProduct",
            model: {
                ...props.apiResult,
                images: [...(props.apiResult.images || []), videoObj1, videoObj2].filter(image => image.id),
            },
            path: props.parameter.path,
        });
        return;
    }
    props.dispatch({
        type: "Data/Products/CompleteLoadProduct",
        model: props.apiResult,
        path: props.parameter.path,
    });
};

replaceInChain(chain, PopulateApiParameter, PopulateApiParameterCustom);
replaceInChain(chain, DispatchCompleteLoadProduct, DispatchCompleteLoadProductCustom);
